import React from 'react';
import clsx from 'clsx';

const variantClasses = {
  default: `
    border-white/10 hover:border-white/30 
    bg-gradient-to-tr from-black/60 to-black/40 
    hover:bg-gradient-to-tr hover:from-white/10 hover:to-black/40 
    hover:shadow-white/20`,
  green: `
    border-green-500/20 hover:border-green-500/50 
    bg-gradient-to-tr from-black/60 to-black/40 
    hover:bg-gradient-to-tr hover:from-green-500/10 hover:to-black/40 
    hover:shadow-green-500/30`,
  indigo: `
    border-indigo-500/20 hover:border-indigo-500/50 
    bg-gradient-to-tr from-black/60 to-black/40 
    hover:bg-gradient-to-tr hover:from-indigo-500/10 hover:to-black/40 
    hover:shadow-indigo-500/30`,
  red: `
    border-red-500/20 hover:border-red-500/50 
    bg-gradient-to-tr from-black/60 to-black/40 
    hover:bg-gradient-to-tr hover:from-red-500/10 hover:to-black/40 
    hover:shadow-red-500/30`,
  pink: `
    border-pink-500/20 hover:border-pink-500/50 
    bg-gradient-to-tr from-black/60 to-black/40 
    hover:bg-gradient-to-tr hover:from-pink-500/10 hover:to-black/40 
    hover:shadow-pink-500/30`,
  white: `
    border-white/15 hover:border-white/40 
    bg-gradient-to-tr from-black/60 to-black/40 
    hover:bg-gradient-to-tr hover:from-white/10 hover:to-black/40 
    hover:shadow-white/30`,
};

const glowGradientClasses = {
  default: 'via-white/10',
  green: 'via-green-400/20',
  indigo: 'via-indigo-400/20',
  red: 'via-red-400/20',
  pink: 'via-pink-400/20',
  white: 'via-white/20',
};

const FancyButton = ({
  icon,
  variant = 'default',
  onClick,
  href,
  target,
  rel,
  className = '',
  ariaLabel = 'Fancy Button',
}) => {
  const baseClasses = clsx(
    'p-4 rounded-full backdrop-blur-lg shadow-lg transition-all duration-300 ease-out cursor-pointer group relative overflow-hidden border',
    'hover:scale-110 active:scale-95 hover:rotate-2 active:rotate-0 hover:shadow-2xl',
    variantClasses[variant],
    className
  );

  const inner = (
    <>
      <div
        className={clsx(
          'absolute inset-0 bg-gradient-to-r from-transparent to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-out',
          glowGradientClasses[variant]
        )}
      />
      <div className="relative z-10">{icon}</div>
    </>
  );

  if (href) {
    return (
      <a
        href={href}
        target={target}
        rel={rel}
        aria-label={ariaLabel}
        className={baseClasses}
      >
        {inner}
      </a>
    );
  }

  return (
    <button onClick={onClick} aria-label={ariaLabel} className={baseClasses}>
      {inner}
    </button>
  );
};

export default FancyButton;
